import { Scrambling } from "../declarations/interface";
import BaseService from "./baseService";

class ProjectService extends BaseService {
  constructor() {
    super("/scramblings");
  }

  async updateScrambling(scrambling: Scrambling) {
    return this.patch(`/${scrambling.id}`, scrambling);
  }

  async createScrambling(scrambling: Scrambling) {
    return this.post("", {
      project_id: scrambling.project_id,
      description: scrambling.description,
      selector: scrambling.selector,
    });
  }

  async deleteScrambling(id: string) {
    return this.remove(`/${id}`);
  }
}

export default new ProjectService();
